// import React, { useEffect } from "react";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
// import BRSRReport from "../../../../../assets/report/brsr_report.pdf";
// import CSSRReport from "../../../../../assets/report/carbon_sink_sequestration_report.pdf";
// import IReport from "../../../../../assets/report/inception_report.pdf";
// import { Button } from "antd";
// import { Modal } from "antd";
// import { CheckCircleFilled } from "@ant-design/icons";
// import PopupCard from "../../../../Auth/PopupCard";
// import { useState } from "react";
// import { getApi, postApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";
// const GenerateReport = ({ onOpen, onClose }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [ReportData, setReportData] = useState([]);
//   const [pageNo, setPageNo] = useState(1);
//   const clientId = useSelector((state) => state.auth.user._id);

//   const pageSize = 10;
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });
//   const location = useLocation();
//   const { projectName, projectId } = location.state || {};
//   console.log(projectId, "projectidsss")
//   const [requestData, setrequestData] = useState({
//     client_id: clientId,
//     report_id: "68e4b5a64378d2de6c721d42",
//     project_id: projectId
//   })
//   const handlePreview = (link) => {
//     if (link) {
//       window.open(link, "_blank", "noopener,noreferrer");
//     } else {
//       alert("Preview not available for this report.");
//     }
//   };

//   const triggerPopup = (type, title, message, duration = 3000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(() => setShowPopup(false), duration);
//   };

//   const handleRequest = async (report, value) => {
//     console.log(report, "repoertsData")
//     const updatedRequestData = {
//       client_id: clientId,
//       report_id: report.key, // Use report.key which contains _id
//       project_id: projectId
//     };

//     try {
//       const response = await postApi(
//         {
//           apiUrl: API_URLS.CREATE_REQUEST_REPORTS,
//           data: updatedRequestData,
//         }
//       );
//       if (response.success) {
//         triggerPopup(
//           "success", // type
//           value, // title
//           "Request is Sent Successfully", // message
//         );
//       }

//     } catch (error) {
//       triggerPopup("error", "Report Failed", "Report Failed");
//     }

//     setTimeout(() => {
//       Modal.destroyAll(); // Close all modals after 2s
//       onClose();
//     }, 2000);
//   };

//   const fetchAllReports = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_REQUEST_REPORTS(pageSize, pageNo)
//       });

//       console.log("Full API Response:", response); // Console entire response

//       if (response.data && response.data.data) {

//         // Map the data to state
//         const requestsData = response.data.data.map((item) => ({
//           key: item._id,
//           label: item.name,
//           link: item.pdf, // Use 'pdf' field from response as link
//           description: item.description,
//           status: item.status
//         }));

//         console.log("Mapped Report Data:", requestsData);
//         setReportData(requestsData);

//         // Console pagination info
//         console.log("Pagination:", response.data.pagination);
//       }

//     } catch (error) {
//       console.error("Error fetching reports:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAllReports(pageNo)
//   }, [pageNo])
//   return (
//     <div>
//       <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="900px">
//         <div>
//           <h3 className=" text-lg text-[#06513D]  px-4">
//             Project Report Details
//           </h3>
//         </div>
//         <div
//           style={{
//             border: "1px solid #ebedf3",
//             borderRadius: "10px",
//           }}
//         >
//           <div className="flex justify-between px-16 pt-6 text-gray-400  text-base font-light">
//             <p>Section</p>
//             <p>Action</p>
//           </div>
//           {ReportData.map((report, index) => (

//             <div
//               key={index}
//               style={{
//                 border: "1px solid #ebedf3",
//                 borderRadius: "10px",
//               }}
//               className="mb-8 mx-12"
//             >
//               <div className="flex justify-between  px-4 h-14  items-center">
//                 <p className="text-base font-light pt-3">{report.label}</p>
//                 <div className="flex gap-4 items-center">
//                   <Button
//                     style={{ background: "#06513D", color: "white" }}
//                     onClick={() => handlePreview(report.link)}
//                   >
//                     Preview
//                   </Button>

//                   <Button
//                     style={{ background: "#06513D", color: "white" }}
//                     onClick={() => handleRequest((report))}
//                   >
//                     Request
//                   </Button>

//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         {showPopup && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//             <PopupCard
//               type={popupData.type}
//               title={popupData.title}
//               message={popupData.message}
//             />
//           </div>
//         )}
//       </DialogBox>
//     </div>
//   );
// };

// export default GenerateReport;

// import React, { useEffect } from "react";
// import { DialogBox } from "../../../../../components/Elements/DialogBox";
// import { ReactComponent as DownloadIcon } from "../../../../../assets/svgs/download-icon.svg";
// import BRSRReport from "../../../../../assets/report/brsr_report.pdf";
// import CSSRReport from "../../../../../assets/report/carbon_sink_sequestration_report.pdf";
// import IReport from "../../../../../assets/report/inception_report.pdf";
// import { Button } from "antd";
// import { Modal } from "antd";
// import { CheckCircleFilled } from "@ant-design/icons";
// import PopupCard from "../../../../Auth/PopupCard";
// import { useState } from "react";
// import { getApi, postApi } from "../../../../../api/api_instance";
// import { API_URLS } from "../../../../../api/apiUrls";
// import { useLocation } from "react-router-dom";
// import { useSelector } from "react-redux";

// const GenerateReport = ({ onOpen, onClose, refreshTable }) => {
//   const [showPopup, setShowPopup] = useState(false);
//   const [ReportData, setReportData] = useState([]);
//   const [pageNo, setPageNo] = useState(1);
//   const clientId = useSelector((state) => state.auth.user._id);

//   const pageSize = 10;
//   const [popupData, setPopupData] = useState({
//     type: "success",
//     title: "Success",
//     message: "",
//   });
//   const location = useLocation();
//   const { projectName, projectId } = location.state || {};
//   console.log(projectId, "projectidsss");

//   const handlePreview = (viewUrl) => {
//     if (viewUrl) {
//       window.open(viewUrl, "_blank", "noopener,noreferrer");
//     } else {
//       alert("Preview not available for this report.");
//     }
//   };

//   const triggerPopup = (type, title, message, duration = 3000) => {
//     setPopupData({ type, title, message });
//     setShowPopup(true);
//     setTimeout(() => setShowPopup(false), duration);
//   };

//   const handleRequest = async (report) => {
//     console.log(report, "repoertsData");
//     const updatedRequestData = {
//       client_id: clientId,
//       report_id: report.key, // Use report.key which contains _id
//       project_id: projectId,
//     };

//     try {
//       const response = await postApi({
//         apiUrl: API_URLS.CREATE_REQUEST_REPORTS,
//         data: updatedRequestData,
//       });

//       if (response.success) {
//         triggerPopup(
//           "success", // type
//           report.label, // title - use report name
//           "Request is Sent Successfully", // message
//         );
//         if (typeof refreshTable === "function") {
//           refreshTable();
//         }
//       }
//     } catch (error) {
//       console.error("Request error:", error);
//       triggerPopup(
//         "error",
//         "Report Failed",
//         "Request Failed. Please try again.",
//       );
//     }

//     setTimeout(() => {
//       Modal.destroyAll(); // Close all modals after 2s
//       onClose();
//     }, 2000);
//   };

//   const fetchAllReports = async () => {
//     try {
//       const response = await getApi({
//         apiUrl: API_URLS.GET_ALL_REQUEST_REPORTS(pageSize, pageNo),
//       });

//       console.log("Full API Response:", response); // Console entire response

//       if (response.data && response.data.data) {
//         // Map the data to state
//         const requestsData = response.data.data.map((item) => ({
//           key: item._id,
//           label: item.name,
//           link: item.pdf, // Original PDF URL
//           viewUrl: item.viewUrl, // SAS token URL for viewing
//           description: item.description,
//           status: item.status,
//         }));

//         console.log("Mapped Report Data:", requestsData);
//         setReportData(requestsData);

//         // Console pagination info
//         console.log("Pagination:", response.data.pagination);
//       }
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//     }
//   };

//   useEffect(() => {
//     fetchAllReports();
//   }, [pageNo]);

//   return (
//     <div>
//       <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="900px">
//         <div>
//           <h3 className="text-lg text-[#06513D] px-4">
//             Project Report Details
//           </h3>
//         </div>
//         <div
//           style={{
//             border: "1px solid #ebedf3",
//             borderRadius: "10px",
//           }}
//         >
//           <div className="flex justify-between px-16 pt-6 text-gray-400 text-base font-light">
//             <p>Section</p>
//             <p>Action</p>
//           </div>
//           {ReportData.map((report, index) => (
//             <div
//               key={report.key || index} // Use report.key as primary key
//               style={{
//                 border: "1px solid #ebedf3",
//                 borderRadius: "10px",
//               }}
//               className="mb-8 mx-12"
//             >
//               <div className="flex justify-between px-4 h-14 items-center">
//                 <p className="text-base font-light pt-3">{report.label}</p>
//                 <div className="flex gap-4 items-center">
//                   <Button
//                     style={{ background: "#06513D", color: "white" }}
//                     onClick={() => handlePreview(report.viewUrl)} // Use viewUrl
//                   >
//                     Preview
//                   </Button>

//                   <Button
//                     style={{ background: "#06513D", color: "white" }}
//                     onClick={() => handleRequest(report)}
//                   >
//                     Request
//                   </Button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//         {showPopup && (
//           <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
//             <PopupCard
//               type={popupData.type}
//               title={popupData.title}
//               message={popupData.message}
//             />
//           </div>
//         )}
//       </DialogBox>
//     </div>
//   );
// };

// export default GenerateReport;
import React, { useState, useEffect } from "react";
import { Button, Modal } from "antd";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { DialogBox } from "../../../../../components/Elements/DialogBox";
import PopupCard from "../../../../Auth/PopupCard";
import { getApi, postApi } from "../../../../../api/api_instance";
import { API_URLS } from "../../../../../api/apiUrls";

const GenerateReport = ({ onOpen, onClose, refreshTable }) => {
  const [showPopup, setShowPopup] = useState(false);
  const [ReportData, setReportData] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const _user = useSelector((state) => state.auth.user);
  const clientId = _user?.client_id?._id || _user?._id;
  const pageSize = 10;
  const [popupData, setPopupData] = useState({
    type: "success",
    title: "Success",
    message: "",
  });

  const location = useLocation();
  const { projectName, projectId } = location.state || {};
  console.log(projectId, "projectidsss");
  const handlePreview = (viewUrl) => {
    if (viewUrl) {
      window.open(viewUrl, "_blank", "noopener,noreferrer");
    } else {
      alert("Preview not available for this report.");
    }
  };

  const triggerPopup = (type, title, message, duration = 3000) => {
    setPopupData({ type, title, message });
    setShowPopup(true);
    setTimeout(() => setShowPopup(false), duration);
  };

  const handleRequest = async (report) => {
    console.log(report, "repoertsData");
    const updatedRequestData = {
      client_id: clientId,
      report_id: report.key, // Use report.key which contains _id
      project_id: projectId,
    };

    try {
      const response = await postApi({
        apiUrl: API_URLS.CREATE_REQUEST_REPORTS,
        data: updatedRequestData,
      });
      if (response.success) {
        triggerPopup(
          "success", // type
          report.label, // title - use report name
          "Request is Sent Successfully", // message
        );

        // ✅ Call refreshTable to update ReportTable component
        if (typeof refreshTable === "function") {
          console.log("Calling refreshTable...");
          refreshTable();
        }

        // ✅ Close modal and cleanup after 2 seconds
        setTimeout(() => {
          Modal.destroyAll(); // Close all modals
          onClose(); // Close the GenerateReport dialog
        }, 2000);
      }
    } catch (error) {
      console.error("Request error:", error);
      triggerPopup(
        "error",
        "Report Failed",
        "Request Failed. Please try again.",
      );

      // Close on error too
      setTimeout(() => {
        Modal.destroyAll();
        onClose();
      }, 2000);
    }
  };

  const fetchAllReports = async () => {
    try {
      const response = await getApi({
        apiUrl: API_URLS.GET_ALL_REQUEST_REPORTS(
          pageSize,
          pageNo,
          projectId,
          clientId,
        ),
      });

      console.log("Full API Response:", response);

      if (response.data && response.data.data) {
        const requestsData = response.data.data.map((item) => ({
          key: item._id,
          label: item.name,

          request_status: item.request_status,
          link: item.pdf,
          viewUrl: item.viewUrl,
          description: item.description,
          status: item.status,
        }));

        setReportData(requestsData);
        console.log("Mapped Report Data:", requestsData.requestSatus);
        console.log("Pagination:", response.data.pagination);
      }
    } catch (error) {
      console.error("Error fetching reports:", error);
    }
  };

  useEffect(() => {
    fetchAllReports();
  }, [pageNo]);

  return (
    <div>
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="900px">
        <div>
          <h3 className="text-lg text-[#06513D] px-4">
            Project Report Details
          </h3>
        </div>
        <div
          style={{
            border: "1px solid #ebedf3",
            borderRadius: "10px",
          }}
        >
          <div className="flex justify-between px-16 pt-6 text-gray-400 text-base font-light">
            <p>Section</p>
            <p>Action</p>
          </div>
          {ReportData.map((report, index) => (
            <div
              key={report.key || index}
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
              }}
              className="mb-8 mx-12"
            >
              <div className="flex justify-between px-4 h-14 items-center">
                <p className="text-base font-light pt-3">{report.label}</p>

                <div className="flex gap-4 items-center">
                  <Button
                    style={{ background: "#06513D", color: "white" }}
                    className="w-28 hover:!bg-[#387464] hover:!border-[#06513D]"
                    onClick={() => handlePreview(report.viewUrl)}
                  >
                    Preview
                  </Button>

                  <Button
                    style={{ background: "#06513D", color: "white" }}
                    className="w-28 hover:!bg-[#387464] hover:!border-[#06513D]"
                    onClick={() => handleRequest(report)}
                    disabled={report.request_status === "requested"}
                  >
                    {report.request_status === "requested"
                      ? "Requested"
                      : "Request"}
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
        {showPopup && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-40">
            <PopupCard
              type={popupData.type}
              title={popupData.title}
              message={popupData.message}
            />
          </div>
        )}
      </DialogBox>
    </div>
  );
};

export default GenerateReport;
